import { render, staticRenderFns } from "./address.vue?vue&type=template&id=552249bd&scoped=true&"
import script from "./address.vue?vue&type=script&lang=js&"
export * from "./address.vue?vue&type=script&lang=js&"
import style0 from "./address.vue?vue&type=style&index=0&id=552249bd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552249bd",
  null
  
)

export default component.exports